/**
 * @fileoverview
 * Webpack entry for enhanced-ux version only.
 * Loads all components and initializes the application.
 */
import { Application } from 't3js';

import '../sass/critical.scss';

import '@buzzfeed/buzzblocks/img/favicon.ico';
import '@buzzfeed/buzzblocks/img/apple-touch-icon.png';
import '@buzzfeed/buzzblocks/img/buzzfeed-webapp-logo.png';

import './tracking/sentry';

import './modules/buzzfeed-login.js';
import './modules/bounce-policy.js';

function App() {
  const startT3 = function(config) {
    Application.init(config);
  };

  return {
    init: function() {
      const config = {
        debug: true
      };
      if (document.readyState === 'complete' ||
        (document.readyState !== 'loading' && !document.documentElement.doScroll)) {
        startT3(config);
      } else {
        document.addEventListener('DOMContentLoaded', function() {
          startT3(config);
        });
      }
    },
    getService: Application.getService.bind(Application),
    on: Application.on.bind(Application),
    off: Application.off.bind(Application),
    broadcast: Application.broadcast.bind(Application),
    startAll: Application.startAll.bind(Application),
    start: Application.start.bind(Application)
  };
}

// start app
window.App = new App();
window.App.init();



// WEBPACK FOOTER //
// /app/static/js/core-entry.js